import { render, staticRenderFns } from "./TemplateFormDataDetailForm.vue?vue&type=template&id=34f460da&"
import script from "./TemplateFormDataDetailForm.vue?vue&type=script&lang=js&"
export * from "./TemplateFormDataDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports